module.exports = __webpack_public_path__ + "img/sistema_constructivo.da76e958.png";